import { render, staticRenderFns } from "./TextElementPreview.vue?vue&type=template&id=67d294e0&scoped=true"
import script from "./TextElementPreview.vue?vue&type=script&lang=js"
export * from "./TextElementPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d294e0",
  null
  
)

export default component.exports